<template>
  <div ref="appContent" class="app-content">
    <el-card>
      <el-form
          :inline="true"
          :model="dataForm"
          @keyup.enter.native="getDataList()"
          ref="queryForm"
      >
        <el-form-item label="合同编号：">
          <OrderDrop v-model="dataForm.agreementCode" size="mini"
                     placeholder="请输入订单编号"></OrderDrop>
        </el-form-item>
        <el-form-item label="出入库：">
          <el-select v-model="dataForm.storeType" size="mini">
            <el-option value="" label="请选择"></el-option>
            <el-option :value="1" label="入库"></el-option>
            <el-option :value="-1" label="出库"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="仓库：">
          <storages v-model="dataForm.storageId" size="mini"></storages>
        </el-form-item>
        <el-form-item label="供应商：">
          <el-input v-model="dataForm.senderName" placeholder="请输入供应商" size="mini"></el-input>
        </el-form-item>
        <el-form-item>

          <el-button @click="getDataList()" size="mini">{{ $t('query') }}</el-button>
        </el-form-item>
<!--        <el-form-item>-->
<!--          <el-button type="warning" @click="doExport()">导出</el-button>-->
<!--        </el-form-item>-->
      </el-form>
      <el-table
          v-loading="dataListLoading"
          :data="dataList"
          border
          style="width: 100%"
          @selection-change="dataListSelectionChangeHandle"
          :max-height="maxTableHeight"
      >
        <el-table-column
            label="行号"
            type="index"
            header-align="center"
            align="center"
            width="50"
        ></el-table-column>

        <el-table-column
            prop="agreementCode"
            label="合同编号"
            header-align="center"
            align="center"
            min-width="120"
            :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
            prop="senderName"
            label="供应商"
            header-align="center"
            align="center"
            min-width="120"
            :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
            prop="receiptCode"
            label="发票号"
            header-align="center"
            align="center"
        ></el-table-column>
        <el-table-column
            v-if="productType === '产品'"
            prop="code"
            label="品番号"
            header-align="center"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="productName"
            label="品名"
            header-align="center"
            align="center"
            min-width="120"
            :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
            prop="color"
            label="颜色"
            header-align="center"
            align="center"
            min-width="100"
        ></el-table-column>
        <el-table-column
            prop="size"
            label="规格"
            header-align="center"
            align="center"
            min-width="120"
        ></el-table-column>
        <el-table-column
            prop="attr1"
            label="幅宽"
            header-align="center"
            align="center"
            v-if="productType === '原料'"
            min-width="100"
        ></el-table-column>
        <el-table-column
            prop="attr2"
            label="克重"
            header-align="center"
            align="center"
            v-if="productType === '原料'"
            min-width="100"
        ></el-table-column>
        <el-table-column
            label="出入库类型"
            header-align="center"
            align="center"
            width="100"
        >
          <template slot-scope="scope">
            <div style="color:#67C23A;" v-if="scope.row.type === 1">
              入库
            </div>
            <div style="color:#F56C6C;" v-else-if="scope.row.type === -1">
              出库
            </div>
          </template>
        </el-table-column>
        <el-table-column
            label="数量"
            header-align="center"
            align="center"
            width="100"
        >
          <template slot-scope="scope">
            <div style="color:#67C23A;" v-if="scope.row.type === 1">
              {{ scope.row.count }}
            </div>
            <div style="color:#F56C6C;" v-else-if="scope.row.type === -1">
              {{ scope.row.count }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            label="收货价格"
            prop="price"
            header-align="center"
            align="center"
            width="100"
        >
        </el-table-column>
        <el-table-column
            prop="storageName"
            label="仓库"
            header-align="center"
            align="center"
            min-width="140"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            prop="operateTime"
            label="出入库日期"
            header-align="center"
            align="center"
            :formatter="timeFormatter"
            width="110"
        >
        </el-table-column>
        <el-table-column label="图片" header-align="center" align="center" width="140">
          <template v-slot:default="scope">
            <img-viewer :imgs="scope.row.imgs" ></img-viewer>
          </template>
        </el-table-column>
        <el-table-column
            :label="$t('handle')"
            fixed="right"
            header-align="center"
            align="center"
            width="130"
        >
          <template slot-scope="scope">
            <el-button
                v-if="$hasPermission('trade:factorystorelog:update')"
                type="text"
                size="small"
                @click="showUpdateDialog(scope.row)"
            >修改
            </el-button
            >
            <el-button
                v-if="$hasPermission('store:log:delete')"
                type="text"
                size="small"
                @click="deleteHandle(scope.row.id)"
            >删除
            </el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
    </el-card>
<!--    <change-log-dialog ref="changeLogDialog"></change-log-dialog>-->
  </div>
</template>

<script>
import moment from 'moment'
import mixinViewModule from '@/mixins/view-module'
import ChangeLogDialog from './change-log'
import OrderDrop from '@/components/order-drop'
import ImgViewer from '@/components/ImgViewer'

export default {
  mixins: [mixinViewModule],
  components: { ChangeLogDialog,OrderDrop,ImgViewer },
  props:{
    type:{
      type:Number,
      default:1
    },
    productType:{
      type:String,
      default:'原料'
    }
  },
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/trade/factorystorelog/page',
        exportURL: '/trade/factorystorelog/export',
        getDataListIsPage: true,
        activatedIsNeed: false,
        deleteURL:'/store'
      },
      dataForm: {
        storageId: '',
        agreementCode: '',
        productType: '',
        storeType: '',
        ids: [],
        senderName:''
      },
      storeTypeName: {
        '1': '入库',
        '-1': '出库',
      },
      currentId: '',
      maxTableHeight: 100,
    }
  },
  computed: {
    optName () {
      return this.storeTypeName[String(this.storeType)]
    },
  },
  watch: {
    type:{
      handler:function(newVal){
        this.dataForm.storeType=newVal
        this.reload()
      },
      immediate:true
    },
    productType:{
      handler:function(newVal){
        this.dataForm.productType=newVal
        this.reload()
      },
      immediate:true
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.maxTableHeight =
          this.$refs.appContent.clientHeight -
          this.$refs.queryForm.$el.clientHeight -
          60
    })
  },
  activated () {

  },
  methods: {
    beforeTableBinding(dataList){
      if(!dataList||dataList.length===0){
        return
      }
      dataList.forEach(item=>{
        if(!item.imgs){
          return
        }
        item.imgs=JSON.parse(item.imgs)
        if(item.imgs.length>0){
          item.previewImg=item.imgs[0]
        }
      })
    },
    //显示修改
    showUpdateDialog (row) {
      this.$refs.changeLogDialog.id = row.id
      this.$refs.changeLogDialog.init()
    },
    timeFormatter(row, column, cellValue, index) {
      if (!cellValue) {
        return "";
      }
      return moment(cellValue).format("yyyy-MM-DD");
    },
  },
}
</script>
